import autobind from 'autobind-decorator';
import * as React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import {Col, Icon, notification, Row, Spin, Switch} from 'antd';
import {connect} from 'redux-scaffolding-ts';
import {Link, RouteComponentProps, withRouter} from 'react-router-dom';
import {
    NewProjectTaskAssignmentItem,
    NewProjectTaskAssignmentStore,
    ProjectTaskAssignmentsStore,
    ProjectTaskAssignmentSummary,
    ProjectTaskAssignmentTableRequestItem
} from 'src/stores/projecttaskassignments-store';
import {ItemState, Query} from 'src/core/stores/dataStore';
import {TableModel, TableView} from 'src/core/ui/collections/table';
import {GridTableView, SpaceMap} from 'src/components/collections/grid-table';
import HttpService, {formatMessage} from 'src/core/services/http.service';
import {CommandResult} from 'src/core/stores/types';
import NewProjectTaskAssignmentView from './projecttaskassignment-new';
import EmployeeEditor from 'src/components/employee-editor';
import ProjectTaskEditor from 'src/components/projecttask-editor';
import {ProjectStore} from 'src/stores/projects-store';
import {ProjectTaskItemsStore, ProjectTaskSummary} from '../../../../stores/projecttasks-store';
import {ProjectMemberItemsStore, ProjectMemberSummary} from '../../../../stores/projectmembers-store';
import {resolve} from '../../../../inversify.config';
import {CacheProps, withCache} from 'src/core/services/cache.service';
import {withIdentity} from '../../../../core/services/authentication';
import {UserProfileProps} from "../../../../components/user-profile";


// tslint:disable-next-line:no-empty-interface
interface ProjectTaskAssignmentsViewProps extends RouteComponentProps<{ companyId: string, projectId: string }>, WithTranslation, CacheProps, UserProfileProps{
    projectName: string | undefined;
    refresh: boolean;
    onRefresh: () => void;
    companyAllowCir: boolean,
    companyAllowCii: boolean,
}

interface ProjectTaskAssignmentsViewState {
    query: Query;
    projectTaskQuery: Query;
    projectMembersQuery: Query;
    gridAssignmentsData: ProjectTaskAssignmentSummary[];
    newProjectTaskAssignmentShown: boolean;
    isGridViewActive: boolean;
}

@connect(['projectTasksAssingments', ProjectTaskAssignmentsStore], ['project', ProjectStore], ['projectmembers', ProjectMemberItemsStore], ['projectTasks', ProjectTaskItemsStore], ["newProjectTaskAssignment", NewProjectTaskAssignmentStore])
class ProjectTaskAssignmentsDashboard extends React.Component<ProjectTaskAssignmentsViewProps, ProjectTaskAssignmentsViewState> {
    @resolve(HttpService)
    private httpService!: HttpService;


    @autobind
    private isReadOnly() {
        const roles = this.props.userProfile?.roles;
        return roles?.includes("CompanyDataViewer") && !["Manager", "Administrator", "ClientAdmin", "FIConsultant"].some(role => roles.includes(role));
    }
    private get newProjectTaskAssignmentStore() {
        return (this.props as any).newProjectTaskAssignment as NewProjectTaskAssignmentStore;
    }

    private get projectMembersStore() {
        return (this.props as any).projectmembers as ProjectMemberItemsStore;
    }

    private get projectAssingmentsStore() {
        return (this.props as any).projectTasksAssingments as ProjectTaskAssignmentsStore;
    }

    private get projectTasksStore() {
        return (this.props as any).projectTasks as ProjectTaskItemsStore;
    }

    private get projectStore() {
        return (this.props as any).project as ProjectStore;
    }

    constructor(props: ProjectTaskAssignmentsViewProps) {
        super(props);
        var queryStored = props.cache.getWithCustomKey("Project-Tasks")

        var query = { searchQuery: '', orderBy: [{ field: 'employeeTitle', direction: 'Ascending', useProfile: true }], skip: 0, take: 10 }

        if (queryStored)
            query = queryStored
        this.state = {
            isGridViewActive: true,
            gridAssignmentsData:[],
            query: query as any,
            projectTaskQuery: { searchQuery: '', orderBy: [{ field: 'title', direction: 'Ascending', useProfile: true }], skip: 0, take: 100 },
            projectMembersQuery: { searchQuery: '', orderBy: [{ field: 'title', direction: 'Ascending', useProfile: true }], skip: 0, take: 100 },
            newProjectTaskAssignmentShown: false,
        };
    }

    componentWillMount() {
        this.projectAssingmentsStore.changeUrl(this.props.match.params.companyId, this.props.match.params.projectId);
        this.load(this.state.query);
        this.loadGridData(
            { searchQuery: '', orderBy: [{ field: 'employeeTitle', direction: 'Ascending', useProfile: true }], skip: 0, take: 10 },
            { searchQuery: '', orderBy: [{ field: 'title', direction: 'Ascending', useProfile: true }], skip: 0, take: 10 })
    }

    componentDidUpdate() {
        if (this.props.refresh) {
            this.load(this.state.query)
            this.loadGridData(this.state.projectMembersQuery, this.state.projectTaskQuery)
            this.props.onRefresh()
        }
    }

    @autobind
    private async load(query: Query) {
        this.props.cache.saveWithCustomKey("Project-Tasks", query);
        //get assignments
        let assignments = await this.projectAssingmentsStore.getAllAsync(query);
        this.setState({ gridAssignmentsData: [...assignments.items] })

        //get project info
        await this.projectStore.getById(this.props.match.params.projectId);
       }

    @autobind
    private async loadGridData(membersQuery: Query, projectTasksQuery: Query) {
        //get project members
        this.projectMembersStore.changeUrlByProject(this.props.match.params.companyId, this.props.match.params.projectId);
        var projectMembers = await this.projectMembersStore.getAllAsync(membersQuery)

        //get project tasks
        this.projectTasksStore.changeUrlByProject(this.props.match.params.companyId, this.props.match.params.projectId);
        var projectTasks = await this.projectTasksStore.getAllAsync(projectTasksQuery)

        let requestItem = {
            taskIds: projectTasks.items.map(x => x.id),
            employeeIds: projectMembers.items.map(x => x.employeeId)
        } as ProjectTaskAssignmentTableRequestItem

        this.loadGridAssignmentsData(requestItem)
    }

    @autobind
    private loadGridAssignmentsData(requestItem: ProjectTaskAssignmentTableRequestItem) {
        this.httpService.post<ProjectTaskAssignmentTableRequestItem, any>(
            `${process.env.PUBLIC_URL}/api/v1/assignments/${this.props.match.params.companyId}/${this.props.match.params.projectId}/table`, requestItem).then(result => {
                this.setState({ gridAssignmentsData: result.data.items })
            })
    }

    @autobind
    private onQueryChanged(query: Query) {
        this.setState({ query }, () => this.load(query));
    }

    @autobind
    private countDownNotification(_notification: any, message: string, description: string, key: string) {
        let secondsToGo = 4;
        _notification({
            key: key,
            message: message + `(${secondsToGo}).`,
            description: description
        });
        const timer = setInterval(() => {
            secondsToGo -= 1;
            _notification({
                key: key,
                message: message + `(${secondsToGo}).`,
                description: description,
                onClose: () => clearInterval(timer),
            });
        }, 1000);
        setTimeout(() => {
            clearInterval(timer);
            notification.close(key);
        }, secondsToGo * 1000);
    }

    @autobind
    private async onSaveItem(item: ProjectTaskAssignmentSummary, state: ItemState) {
        return await this.projectAssingmentsStore.saveAsync(`${item.id}`, item, state);
    }

    @autobind
    private async onSaveNewGridItem(employeeId: string, taskId: string): Promise<CommandResult<any>> {
        let newItem = {
            employeeId: employeeId,
            projectTaskId: [taskId],
            projectId: this.props.match.params.projectId
        } as NewProjectTaskAssignmentItem
        this.newProjectTaskAssignmentStore.changeUrl(this.props.match.params.companyId, this.props.match.params.projectId);
        this.newProjectTaskAssignmentStore.createNew(newItem);
        return this.newProjectTaskAssignmentStore.submit()
    }

    @autobind
    private async onDeleteGridItem(employeeId: string, taskId: string, assignmentId: string): Promise<CommandResult<any>> {
        this.projectAssingmentsStore.changeUrl(this.props.match.params.companyId, this.props.match.params.projectId);
        return this.projectAssingmentsStore.deleteAsync(assignmentId);
    }

    @autobind
    private async onDeleteRow(item: ProjectTaskAssignmentSummary, state: ItemState): Promise<CommandResult<any>> {
        return await this.projectAssingmentsStore.deleteAsync(`${item.id}`);
    }

    @autobind
    private switchTableViews() {
        this.setState({ isGridViewActive: !this.state.isGridViewActive }, () => {
            if (this.state.isGridViewActive)
                this.loadGridData(this.state.projectMembersQuery, this.state.projectTaskQuery)
            else
                this.load(this.state.query)
        })
    }

    @autobind
    private onNewItem() {
        this.setState({ newProjectTaskAssignmentShown: true });
    }

    @autobind
    private onNewItemClosed(id: string | undefined) {
        this.setState({ newProjectTaskAssignmentShown: false });
        this.load(this.state.query);
    }

    public render() {
        const { t } = this.props as any;
        let isReadOnly = this.isReadOnly()
        const tableModel = {
            query: this.state.query,
            columns: [
                {
                    sortable: true,
                    field: 'employeeTitle',
                    title: t('Employee'),
                    renderer: (data) => <span>
                        <Link to={{
                            pathname: `/time-tracking/admin/companies/${this.props.match.params.companyId}/projects/${this.props.match.params.projectId}/${data.employeeId}`,
                            state: {
                                titles: [...(this.props.location.state ? (this.props.location.state as any).titles || [] : []),
                                { url: `/time-tracking/admin/companies/${this.props.match.params.companyId}/projects/${this.props.match.params.projectId}`, title: this.props.projectName }]
                            }
                        }}><Icon type="user" />&nbsp;<span>{data.employeeTitle.split('(')[0]}</span><span style={{ fontSize: 12 }}>({data.employeeTitle.split('(')[1]}</span></Link>
                    </span>,
                    editor: (data) => <EmployeeEditor placeholder={t("Name")} companyId={this.props.match.params.companyId} />

                },
                {
                    sortable: true,
                    field: 'projectTaskTitle',
                    title: t('Task'),
                    renderer: (data) => <span>{data.projectTaskTitle}</span>,
                    editor: (data) =>
                        <ProjectTaskEditor companyAllowCii={this.props.companyAllowCii} companyAllowCir={this.props.companyAllowCir} disabled={isReadOnly} companyId={this.props.match.params.companyId} projectId={this.props.match.params.projectId} placeholder={t("Name")} />
                },
            ],
            data: this.projectAssingmentsStore.state,
            sortFields: [{
                field: 'employeeTitle',
                text: t('Employee name'),
                useProfile: true
            },
            {
                field: 'projectTaskTitle',
                text: t('Project task name'),
                useProfile: true
            }],
        } as TableModel<ProjectTaskAssignmentSummary>;

        var tasksSpaceMap = {
            model: {
                query: this.state.projectTaskQuery,
                data: this.projectTasksStore.state,
                onQueryChanged: (query) => {
                    this.projectTasksStore.changeUrlByProject(this.props.match.params.companyId, this.props.match.params.projectId);
                    this.projectTasksStore.getAllAsync(query).then(async (result) => {
                        this.setState({ projectTaskQuery: query })
                        let requestItem = {
                            taskIds: result.items.map(x => x.id),
                            employeeIds: this.projectMembersStore.state.items.map(x => x.item.employeeId)
                        } as ProjectTaskAssignmentTableRequestItem
                        this.loadGridAssignmentsData(requestItem);
                    })  
                }
            },
            width: 250,
            itemKey: "id",
            itemText: "title",
            key: "tasks",
            title: t("Tasks"),
            ellipsis: true
        } as SpaceMap<ProjectTaskSummary>
        var membersSpaceMap = {
            model: {
                query: this.state.projectMembersQuery,
                data: this.projectMembersStore.state,
                onQueryChanged: (query) => {
                    this.projectMembersStore.changeUrlByProject(this.props.match.params.companyId, this.props.match.params.projectId);
                    this.projectMembersStore.getAllAsync(query).then(async (result) => {
                        this.setState({ projectMembersQuery: query })
                        let requestItem = {
                            taskIds: this.projectTasksStore.state.items.map(x => x.item.id),
                            employeeIds: result.items.map(x => x.employeeId)
                        } as ProjectTaskAssignmentTableRequestItem
                        this.loadGridAssignmentsData(requestItem);
                    }) 
                }
            },
            width: 50,
            height: 200,
            showSideways: true,
            itemKey: "employeeId",
            itemText: "employeeTitle",
            key: "members",
            title: t("Employees"),
            ellipsis: true
        } as SpaceMap<ProjectMemberSummary>
        var assingmentsSpaceMap = {
            model: {
                query: { searchQuery: '', orderBy: [{ field: 'employeeTitle', direction: 'Ascending', useProfile: true }], skip: 0, take: 100 },
                data: this.projectAssingmentsStore.state,
                onQueryChanged: () => { }
            },
            alternativeDataSource: this.state.gridAssignmentsData,
            itemKey: "id",
            itemText: "title",
            key: "assingments",
            title: "assingments"
        } as SpaceMap<ProjectTaskAssignmentSummary>

        return <Spin size='large' spinning={this.projectTasksStore.state.isBusy || this.projectStore.state.isBusy || this.projectMembersStore.state.isBusy || this.projectAssingmentsStore.state.isBusy}>
            <Row gutter={10} style={{ marginBottom: 10 }} type="flex" justify="start">
                <Col>
                    <Switch defaultChecked={true} onChange={this.switchTableViews} title={t('Toggle grid view')} />
                </Col>
                <Col>
                    <div>
                        {t('Toggle grid view')}
                    </div>
                </Col>
            </Row>
            {!this.state.isGridViewActive && < TableView
                showDeleteStatusWindow
                rowKey='id'
                model={tableModel}
                error={this.projectTasksStore.state.result && !this.projectTasksStore.state.result.isSuccess && formatMessage(this.projectTasksStore.state.result)}
                embedded={false}
                onQueryChanged={(q: Query) => this.onQueryChanged(q)}
                onRefresh={() => this.load(this.state.query)}
                canEdit={false}
                onSaveRow={this.onSaveItem}
                canDelete={!this.isReadOnly()}
                onDeleteRow={this.onDeleteRow}
                canCreateNew={!this.isReadOnly()}
                onNewItem={this.onNewItem}>
            </TableView>}
            {this.state.isGridViewActive && <GridTableView<ProjectMemberSummary, ProjectTaskSummary, ProjectTaskAssignmentSummary>
                onRefresh={this.loadGridData}
                onSaveItem={this.onSaveNewGridItem}
                onDeleteItem={this.onDeleteGridItem}
                xData={membersSpaceMap}
                yData={tasksSpaceMap}
                cellData={assingmentsSpaceMap}
                xDataIndexZ="employeeId"
                yDataIndexZ="projectTaskId"
                scroll={{ x: 1500 }}
                readOnly={this.isReadOnly()} />
            }
            {this.state.newProjectTaskAssignmentShown && <NewProjectTaskAssignmentView companyAllowCii={this.props.companyAllowCii} companyAllowCir={this.props.companyAllowCir} isPrivateProject={this.projectStore.state.item != undefined ? this.projectStore.state.item.isPrivate : false} companyId={this.props.match.params.companyId} projectId={this.props.match.params.projectId} onClose={this.onNewItemClosed} />}
        </Spin>
    }
}

// Wire up the React component to the Redux store
export default withCache(withTranslation()(withIdentity(withRouter(ProjectTaskAssignmentsDashboard))));
